import { css } from 'styled-components';
import { breakpoint } from './breakpoints';

/*
	0: 0px
	XS: 16px -      - 24px
	S:  16px - 24px - 32px
	M:  24px - 32px - 40px
	L:  32px - 40px - 48px
	XL: 40px - 48px - 56px
*/

type size = 'None' | 'ExtraSmall' | 'Small' | 'Medium' | 'Large' | 'ExtraLarge';
type selector =
  | 'margin'
  | 'margin-top'
  | 'margin-bottom'
  | 'padding'
  | 'padding-top'
  | 'padding-bottom';

export const spacing = (size: size, selector: selector) => {
  switch (size) {
    case 'None':
      return css`
        ${selector}: 0;
      `;
    case 'ExtraSmall':
      return css`
        ${selector}: 1.6rem;
        ${breakpoint('large')} {
          ${selector}: 2.4rem;
        }
      `;
    case 'Small':
      return css`
        ${selector}: 1.6rem;
        ${breakpoint('medium')} {
          ${selector}: 2.4rem;
        }
        ${breakpoint('large')} {
          ${selector}: 3.2rem;
        }
      `;
    case 'Medium':
      return css`
        ${selector}: 2.4rem; // default?
        ${breakpoint('medium')} {
          ${selector}: 3.2rem;
        }
        ${breakpoint('large')} {
          ${selector}: 4.0rem;
        }
      `;
    case 'Large':
      return css`
        ${selector}: 3.2rem;
        ${breakpoint('medium')} {
          ${selector}: 4.0rem;
        }
        ${breakpoint('large')} {
          ${selector}: 4.8rem;
        }
      `;
    case 'ExtraLarge':
      return css`
        ${selector}: 4.0rem;
        ${breakpoint('medium')} {
          ${selector}: 4.8rem;
        }
        ${breakpoint('large')} {
          ${selector}: 5.6rem;
        }
      `;
  }
};
